export default __webpack_public_path__ + "static/media/arrow-forward-white.9b9ba4b6.svg";